// see /middleware/auth.js
// This file is here only so that the frontend can easily import this config
export const accessLevels = {
    'public': 0,
    'visitor': 10,
    'user': 20,
    'staff': 30,
    'admin': 100,
};